
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip8 extends Vue {}
